<script setup>
import { computed } from 'vue'
import { ArrowLongRightIcon } from '@heroicons/vue/24/outline'

const props = defineProps({
    status: Number,
})

const title = computed(() => {
    return {
        503: '503: Služba není dostupná',
        500: '500: Interní chyba serveru',
        419: '419: Vypršel časový limit',
        405: '405: Metoda není povolena',
        404: '404: Stránka nenalezena',
        403: '403: Zakázaný přístup',
        401: '401: Neautorizovaný přístup',
    }[props.status]
})

const description = computed(() => {
    return {
        503: 'Omlouváme se, provádíme údržbu. Prosím, vraťte se brzy.',
        500: 'Jejda, něco se stalo na našich serverech.',
        419: 'Stránka trvá příliš dlouho na odeslání požadavku a tak token vyprší.',
        405: 'Omlouváme se, stránka, kterou hledáte, nemohla být otevřena.',
        404: 'Omlouváme se, stránka, kterou hledáte, nebyla nalezena.',
        403: 'Omlouváme se, máte zakázán přístup k této stránce.',
        401: 'Omlouváme se, nemáte oprávnění k přístupu k této stránce',
    }[props.status]
})
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <section class="bg-zinc-50">
        <div class="container mx-auto flex h-screen flex-col items-center px-6 lg:flex-row">
            <div>
                <div class="flex max-w-md flex-col items-center justify-center lg:items-start">
                    <h1 class="mt-3 text-2xl font-semibold text-gray-800 md:text-3xl">
                        {{ title }}
                    </h1>

                    <p class="mt-4 text-center text-gray-500">
                        {{ description }}
                    </p>

                    <div class="mt-6 flex items-center gap-x-3">
                        <a
                            href="/"
                            aria-label="Vrátit se domů"
                            class="shrink-0 rounded-lg bg-red-500 px-5 py-2 text-sm tracking-wide text-white transition-colors duration-200 hover:bg-red-600 sm:w-auto"
                        >
                            Vrátit se domů
                        </a>
                    </div>
                </div>

                <div class="mt-20">
                    <h2 class="font-robotoSlab text-lg">Další nabídka</h2>

                    <div class="mt-2 flex flex-col space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0">
                        <div class="space-y-6">
                            <div class="group relative rounded-lg bg-white p-4">
                                <h2 class="text-md inline-flex items-center font-robotoSlab text-zinc-800">
                                    <span>Podniky</span>
                                </h2>

                                <p class="mt-2 text-sm text-gray-500">Přejít na seznam všech podniků.</p>

                                <div class="faster-animation mt-5 flex items-center justify-center rounded-md py-2 group-hover:bg-black/5">
                                    <ArrowLongRightIcon class="size-7 text-zinc-600" />
                                </div>

                                <a
                                    href="/podniky"
                                    class="absolute inset-0"
                                    aria-label="Přejít na seznam všech podniků"
                                />
                            </div>
                        </div>

                        <div class="space-y-6">
                            <div class="group relative rounded-lg bg-white p-4">
                                <h2 class="text-md inline-flex items-center font-robotoSlab text-zinc-800">
                                    <span>Blogy</span>
                                </h2>

                                <p class="mt-2 text-sm text-gray-500">Přejít na seznam všech blogů.</p>

                                <div class="faster-animation mt-5 flex items-center justify-center rounded-md py-2 group-hover:bg-black/5">
                                    <ArrowLongRightIcon class="size-7 text-zinc-600" />
                                </div>

                                <a
                                    href="/blog"
                                    class="absolute inset-0"
                                    aria-label="Přejít na seznam všech blogů"
                                />
                            </div>
                        </div>

                        <div class="space-y-6">
                            <div class="group relative rounded-lg bg-white p-4">
                                <h2 class="text-md inline-flex items-center font-robotoSlab text-zinc-800">
                                    <span>Služby</span>
                                </h2>

                                <p class="mt-2 text-sm text-gray-500">Přejít na seznam všech služeb.</p>

                                <div class="faster-animation mt-5 flex items-center justify-center rounded-md py-2 group-hover:bg-black/5">
                                    <ArrowLongRightIcon class="size-7 text-zinc-600" />
                                </div>

                                <a
                                    href="/sluzby"
                                    class="absolute inset-0"
                                    aria-label="Přejít na seznam všech služeb"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-20 flex justify-center xl:ml-auto xl:mt-0 xl:w-5/12">
                <img
                    src="/src/logo/kamzajitolomouc-logo.png"
                    :alt="'kamzajitolomouc - error ' + status"
                    class="size-40 xl:size-72"
                />
            </div>
        </div>
    </section>
</template>
